export default __webpack_public_path__ + "static/gallery4-c786fc5ce0f0c62a5f8fccf6db861cc2.png";